import axios from 'axios';
import { useAuthStore } from '@/stores/auth.store';
import { useToastStore } from '@/stores/toast.store';
const BASE_URL = process.env.VITE_CMS_API_BASE_URL ?? 'http://localhost:3010/api/v1';
export const api = axios.create({
    baseURL: BASE_URL,
    timeout: 15_000,
});
// Attach JWT token
api.interceptors.request.use((config) => {
    const auth = useAuthStore();
    if (auth.accessToken && config.headers) {
        config.headers.Authorization = `Bearer ${auth.accessToken}`;
    }
    return config;
});
// Handle errors + auto refresh + toast
api.interceptors.response.use((res) => res, async (error) => {
    const auth = useAuthStore();
    const toast = useToastStore();
    if (!error.response) {
        toast.show('Không kết nối được tới server', 'error');
        return Promise.reject(error);
    }
    const { status, data } = error.response;
    const code = data?.error?.code;
    const message = data?.error?.message ?? 'Đã có lỗi xảy ra';
    if (status === 401 && code !== 'INVALID_CREDENTIALS') {
        // Token hết hạn → đăng xuất
        await auth.logout();
        toast.show('Phiên đăng nhập đã hết hạn', 'warning');
        return Promise.reject(error);
    }
    if (status === 403) {
        toast.show('Bạn không có quyền thực hiện hành động này', 'error');
    }
    else if (status === 429) {
        toast.show('Bạn thao tác quá nhanh, vui lòng thử lại sau', 'warning');
    }
    else if (status >= 500) {
        toast.show(`Lỗi máy chủ: ${message}`, 'error');
    }
    else {
        // Không tự toast lỗi 4xx khác - để page tự xử lý
    }
    return Promise.reject(error);
});
/**
 * Helper để bóc data ra khỏi envelope { success, data, meta }.
 */
export async function unwrap(promise) {
    const res = await promise;
    return res.data.data;
}
export async function unwrapWithMeta(promise) {
    const res = await promise;
    return { data: res.data.data, meta: res.data.meta };
}
